module.exports = __webpack_public_path__ + "img/oanda-side-panel-2-en.f45265a1.svg";